var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import { enums } from '@optimizely/optimizely-sdk';
import { getCookieDomain } from '@bombas/react/util';
import hive from '@bombas/hive';
import { getUserAttributes } from './userAttributes';
import { BROWSER_GUID_COOKIE, getStaticBrowserIdentifier, getUserId } from '../identification';
import { getOptimizelyClient, getOptimizelyClientSSR } from './client';
import { isBrowser } from '../ssr';
var userContext;
var OPTIMIZELY_LOGS_COOKIE = 'optimizelyLogLevel';
/**
 * Generates and reuses an Optimizely user context.
 * It creates the context once and reuses the instance on subsequent calls,
 * updating attributes as needed.
 *
 * @param {Record<string, unknown>} [eventAttributes] - Optional event-level attributes.
 * @param {APIRequest} [req] - Optional server request object when used server-side.
 * @returns {Promise<OptimizelyUserContext | false>} The user context.
 */
export var createUser = function () {
    var args_1 = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args_1[_i] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (eventAttributes, req) {
        var client, browserGuid, userLevelAttributes, allAttributes, context;
        if (eventAttributes === void 0) { eventAttributes = {}; }
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    client = isBrowser()
                        ? getOptimizelyClient()
                        : req && getOptimizelyClientSSR(req);
                    if (!client)
                        return [2 /*return*/, false];
                    return [4 /*yield*/, client.onReady()];
                case 1:
                    _a.sent();
                    // Reuse existing context if available, add any new event attributes to it
                    if (isBrowser() && userContext) {
                        // Add event attributes to existing userContext
                        Object.entries(eventAttributes).forEach(function (_a) {
                            var key = _a[0], value = _a[1];
                            userContext === null || userContext === void 0 ? void 0 : userContext.setAttribute(key, value);
                        });
                        return [2 /*return*/, userContext];
                    }
                    browserGuid = isBrowser()
                        ? getStaticBrowserIdentifier()
                        : req === null || req === void 0 ? void 0 : req.cookies[BROWSER_GUID_COOKIE];
                    if (!browserGuid)
                        return [2 /*return*/, false];
                    userLevelAttributes = getUserAttributes(req);
                    allAttributes = __assign(__assign({}, userLevelAttributes), eventAttributes);
                    context = client.createUserContext(browserGuid, allAttributes);
                    // Store the context for reuse, but only on the client side
                    if (isBrowser()) {
                        userContext = context;
                    }
                    return [2 /*return*/, context];
            }
        });
    });
};
/**
 * Retrieves the log level for Optimizely SDK based on URL parameters, cookies, or defaults.
 *
 * The function checks for a log level specified in the URL query parameters (`optimizely_logs`),
 * validates it against accepted log levels, and stores it in a cookie if valid. If no valid log
 * level is found in the URL, it checks for a previously stored cookie value. If neither is found,
 * it defaults to the "error" log level.
 *
 * @returns {string} The determined log level, which can be one of the accepted log levels or "error" as a fallback.
 */
export var getLogLevel = function () {
    var _a, _b;
    var acceptedLogLevels = Object.keys(enums.LOG_LEVEL || {}).map(function (l) {
        return l.toLowerCase();
    });
    if (isBrowser()) {
        // Check URL params for new log level
        var urlParams = new URLSearchParams(window.location.search);
        var urlLogLevel = (_a = urlParams.get('optimizely_logs')) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        if (urlLogLevel && acceptedLogLevels.includes(urlLogLevel)) {
            Cookies.set(OPTIMIZELY_LOGS_COOKIE, urlLogLevel, {
                domain: getCookieDomain()
            });
            return urlLogLevel;
        }
        // Check for optimizely logs cookie
        var cookieLogLevel = (_b = Cookies.get(OPTIMIZELY_LOGS_COOKIE)) === null || _b === void 0 ? void 0 : _b.toLowerCase();
        if (cookieLogLevel && acceptedLogLevels.includes(cookieLogLevel)) {
            return cookieLogLevel;
        }
    }
    // Fallback to error level logs
    return 'error';
};
/**
 * Checks if a specific consent group is present in the Optanon consent cookie.
 *
 * @param optanonCookie - The Optanon consent cookie string, which may be undefined.
 * @param group - The consent group to check for.
 * @returns A boolean indicating whether the specified consent group is included in the cookie.
 */
export var checkOptanonConsentGroup = function (optanonCookie, group) {
    if (!optanonCookie || !group)
        return false;
    var match = optanonCookie.match(/groups=([^&]*)/);
    if (!match || match.length < 2)
        return false;
    var groups = match[1].split(',');
    return groups.includes(group);
};
/**
 * Determines whether a feature flag has an override source, either from a newly provided URL parameter
 * or a previously persisted value in session storage. If a value is specified in a URL parameter,
 * it takes precedence over any value already stored in the session.
 *
 * @param {string} featureName
 * @returns {string|null}
 *
 * Implicit `test` variation
 * @example ?feature=featureName
 *
 * For a specific variation
 * @example ?feature=featureName:variationKey
 *
 * To remove an existing feature override from the session
 * @example ?feature=featureName:0
 */
export var resolveFeatureFlagOverride = function (featureName) {
    var BOM_FEATURE_PREFIX = 'bom_feature';
    var urlSearchParams = new URLSearchParams(window.location.search);
    var featureParam = urlSearchParams.get('feature');
    if (featureParam) {
        var _a = featureParam.split(':'), name_1 = _a[0], _b = _a[1], value = _b === void 0 ? 'test' : _b;
        if (name_1 === featureName) {
            var STORAGE_KEY = "".concat(BOM_FEATURE_PREFIX, "_").concat(featureName);
            if (value === '0') {
                sessionStorage.removeItem(STORAGE_KEY);
            }
            else if (value) {
                sessionStorage.setItem(STORAGE_KEY, value);
            }
        }
    }
    return sessionStorage.getItem("".concat(BOM_FEATURE_PREFIX, "_").concat(featureName));
};
/**
 * Optimizely wrapper to return if a user is bucketed into a feature - does not bucket them, but returns their "decision"
 * @param {string} featureName
 * @returns {Promise<OptimizelyDecision | false>}
 * {
 *   enabled: boolean, whether the test itself is on or off
 *   variationKey: string, the group the user would be bucketed into (control, test, etc)
 *   flagKey: string, the name of the flag/experiment
 *   ruleKey: string, the name of the rule being used
 *   reasons: string array, the reasons for any returned errors
 * }
 *
 * @see {@link https://docs.developers.optimizely.com/feature-experimentation/docs/optimizelydecision-javascript}
 */
export var decide = function (featureName) { return __awaiter(void 0, void 0, void 0, function () {
    var forcedFeature, user, decision, bomCountry, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                forcedFeature = resolveFeatureFlagOverride(featureName);
                if (forcedFeature) {
                    return [2 /*return*/, {
                            enabled: true,
                            variationKey: forcedFeature,
                            flagKey: featureName,
                            ruleKey: 'forced',
                            reasons: []
                        }];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 5, , 6]);
                // NOTE: This is a temporary solution to ensure that bombas-guid has been requested *before* we attempt to create a user context.
                // This is necessary because the user context creation requires a user ID, which is sourced from the bombas-guid cookie.
                // In a nearterm follow up, we will refactor this to ensure that the user ID is available before we attempt to create a user context or call `getStaticBrowserIdentifier`.
                return [4 /*yield*/, getUserId()];
            case 2:
                // NOTE: This is a temporary solution to ensure that bombas-guid has been requested *before* we attempt to create a user context.
                // This is necessary because the user context creation requires a user ID, which is sourced from the bombas-guid cookie.
                // In a nearterm follow up, we will refactor this to ensure that the user ID is available before we attempt to create a user context or call `getStaticBrowserIdentifier`.
                _b.sent();
                return [4 /*yield*/, createUser({
                        Pathname: isBrowser() ? window.location.pathname : ''
                    })];
            case 3:
                user = _b.sent();
                if (!user)
                    return [2 /*return*/, false];
                decision = user.decide(featureName);
                bomCountry = localStorage.getItem('_bomCountry');
                if (!bomCountry || bomCountry !== 'US') {
                    // eslint-disable-next-line
                    console.error("[BOM-COUNTRY]: Missing or invalid bomCountry ('".concat(bomCountry, "')"));
                }
                user.trackEvent('bucket_country', {
                    text: bomCountry || ''
                });
                // Track users test bucket in Heap
                return [4 /*yield*/, hive.track('BUCKET_ASSIGN', {
                        featureName: featureName,
                        bucket: (decision === null || decision === void 0 ? void 0 : decision.variationKey) || false
                    })];
            case 4:
                // Track users test bucket in Heap
                _b.sent();
                return [2 /*return*/, decision];
            case 5:
                _a = _b.sent();
                return [2 /*return*/, false];
            case 6: return [2 /*return*/];
        }
    });
}); };
/**
 * Determines the Optimizely decision for a given feature on the server side.
 * This function is intended to be used in a Next.js API route.
 *
 * @param req - The incoming Next.js API request object.
 * @param featureName - The name of the feature to evaluate.
 * @returns A promise that resolves to an `OptimizelyDecision` object if the decision is successful,
 *          or `false` if the client is unavailable, the user context cannot be created, or an error occurs.
 */
export var decideServer = function (req, featureName, query) { return __awaiter(void 0, void 0, void 0, function () {
    var forcedFeature, pathname, user, decision, _a;
    var _b, _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                forcedFeature = Array.isArray(query === null || query === void 0 ? void 0 : query.feature)
                    ? (_b = query.feature[0]) === null || _b === void 0 ? void 0 : _b.split(':')[1]
                    : (_c = query === null || query === void 0 ? void 0 : query.feature) === null || _c === void 0 ? void 0 : _c.split(':')[1];
                if (forcedFeature) {
                    return [2 /*return*/, {
                            enabled: true,
                            variationKey: forcedFeature,
                            flagKey: featureName,
                            ruleKey: 'forced',
                            reasons: []
                        }];
                }
                _d.label = 1;
            case 1:
                _d.trys.push([1, 3, , 4]);
                pathname = req.url ? req.url.split('?')[0] : '';
                return [4 /*yield*/, createUser({ Pathname: pathname }, req)];
            case 2:
                user = _d.sent();
                if (!user)
                    return [2 /*return*/, false];
                decision = user.decide(featureName);
                return [2 /*return*/, decision];
            case 3:
                _a = _d.sent();
                return [2 /*return*/, false];
            case 4: return [2 /*return*/];
        }
    });
}); };
/**
 * Buckets users into an experiment with provided experiment key
 * @param {string} featureName - flag for the experiment
 * @param {object} [options]
 * @param {boolean} [options.bucketUser=true] - when true, the test bucketing will occur.
 * When false, conditions for bucketing into test have not been met yet
 * @param {boolean} [options.limitBucketing=false] - when true, the bucket function will only be executed once
 * @returns {false | string} - false, indicating no test experience should be displayed; or string indicating the variation to display
 * Note: Expects test to be configured with an "off" or "control" variation.
 */
export var useDecide = function (featureName, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.bucketUser, bucketUser = _c === void 0 ? true : _c, _d = _b.limitBucketing, limitBucketing = _d === void 0 ? false : _d;
    var _e = useState(false), testVariant = _e[0], setTestVariant = _e[1];
    var _f = useState(false), hasBeenBucketed = _f[0], setHasBeenBucketed = _f[1];
    useEffect(function () {
        var bucket = function () { return __awaiter(void 0, void 0, void 0, function () {
            var testDecision, variationKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, decide(featureName)];
                    case 1:
                        testDecision = _a.sent();
                        variationKey = testDecision && testDecision.variationKey;
                        if (variationKey &&
                            !['off', 'control'].includes(variationKey.toLowerCase())) {
                            setTestVariant(variationKey);
                        }
                        if (limitBucketing) {
                            setHasBeenBucketed(true);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        if (bucketUser &&
            (!limitBucketing || (limitBucketing && !hasBeenBucketed))) {
            bucket();
        }
    }, [featureName, bucketUser, limitBucketing, hasBeenBucketed]);
    return testVariant;
};
/**
 * Tracks an event for a user on Optimizely
 * @param {String} event event string key
 * @param {Object} userAttrs optional user attributes to be included with the event
 * @param {Object} eventTags optional attributes to be included with the event
 * @deprecated Please use `@bombas/hive` instead.
 */
export var track = function (event_1) {
    var args_1 = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args_1[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, __spreadArray([event_1], args_1, true), void 0, function (event, userAttrs, eventTags) {
        var client, deviceAttrs, attrs, browserGuid, params, _a;
        if (userAttrs === void 0) { userAttrs = {}; }
        if (eventTags === void 0) { eventTags = {}; }
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    client = getOptimizelyClient();
                    if (!client)
                        return [2 /*return*/];
                    deviceAttrs = getUserAttributes();
                    attrs = __assign(__assign(__assign({}, userAttrs), { IsReturningUser: !!Cookies.get('optimizelyNewCustomerOfferEmailCaptureImpression'), Pathname: isBrowser() ? window.location.pathname : '' }), deviceAttrs);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    browserGuid = getStaticBrowserIdentifier();
                    return [4 /*yield*/, client.onReady()];
                case 2:
                    _b.sent();
                    params = new URLSearchParams(window.location.search);
                    if (params.get('optimizely_log')) {
                        /* eslint-disable-next-line no-console */
                        console.log('Optimizely Bombas:', event, browserGuid, attrs, eventTags);
                    }
                    if (browserGuid) {
                        client.track(event, browserGuid, attrs, eventTags);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    });
};
export var __resetUserContextForTest = function () {
    userContext = undefined;
};
